module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"uk":{"lectures":"Лекції","masterclasses":"Майстеркласи","conferences":"Конференції"},"en":{"lectures":"Lectures","masterclasses":"Master Classes","conferences":"Conferences"}}')
  delete Component.options._Ctor
}
